var version = {
    "name":      "dativery",
    "buildDateCode": "20260319-101325",
    "buildDate": "Thu Mar 19 2026 10:13:25 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260319-101325",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;